const GuestForm = ({
  handleGuestChange,
  handleSubmit,
  cartTotal,
  validationErrors,
  isRedirecting,
  setIsConsentCheckedprop,
}) => {
  return (
    <div className="checkout-card form-section brightness">
      <h3 className="section-title text-clip">Add Your Details</h3>

      {/* {validationErrors && validationErrors.length > 0 && ( */}
      <div
        style={{
          backgroundColor: "rgb(213 196 196)",
          border: "1px solid #fcc",
          borderRadius: "4px",
          padding: "12px",
          marginBottom: "20px",
        }}
      >
        <strong className="text-clip" style={{ "--clip-color": "#c33" }}>
          Please fix the following errors:
        </strong>
        <ul style={{ margin: "8px 0 0 0", paddingLeft: "20px" }}>
          {validationErrors.map((error, idx) => (
            <li
              className="text-clip"
              key={idx}
              style={{ "--clip-color": "#c33", marginBottom: "4px" }}
            >
              {error}
            </li>
          ))}
        </ul>
      </div>
      {/* )} */}

      <div className="form-row">
        <div className="form-group half-width">
          <label className="input-label text-clip">First Name *</label>
          <input
            type="text"
            name="firstName"
            className="form-input"
            onChange={handleGuestChange}
          />
        </div>
        <div className="form-group half-width">
          <label className="input-label text-clip">Last Name *</label>
          <input
            type="text"
            name="lastName"
            className="form-input"
            onChange={handleGuestChange}
          />
        </div>
      </div>

      <div className="form-group">
        <label className="input-label text-clip">Username *</label>
        <input
          type="text"
          name="username"
          className="form-input"
          onChange={handleGuestChange}
        />
      </div>

      <div className="form-group">
        <label className="input-label text-clip">Address *</label>
        <input
          type="text"
          name="address"
          className="form-input"
          onChange={handleGuestChange}
        />
      </div>

      <div className="form-group">
        <label className="input-label text-clip">Phone number *</label>
        <input
          type="text"
          name="phone"
          className="form-input"
          onChange={handleGuestChange}
        />
      </div>

      <div className="form-group">
        <label className="input-label text-clip">Email Address *</label>
        <input
          type="email"
          name="email"
          className="form-input"
          onChange={handleGuestChange}
        />
      </div>

      <div className="form-group">
        <label className="input-label text-clip">Password *</label>
        <input
          type="password"
          name="password"
          className="form-input"
          onChange={handleGuestChange}
        />
      </div>

      <div className="form-group">
        <label className="input-label text-clip">Confirm Password *</label>
        <input
          type="password"
          name="confirmPassword"
          className="form-input"
          onChange={handleGuestChange}
        />
      </div>

      {!setIsConsentCheckedprop && (
        <div className="form-group">
          <label className="input-label" style={{ color: "red" }}>
            *Note: You must accept the Refund Policy and Parent/Guardian Consent
            to proceed with payment.
          </label>
        </div>
      )}

      <button
        className="place-order-btn"
        onClick={handleSubmit}
        disabled={!setIsConsentCheckedprop || isRedirecting}
      >
        {isRedirecting
          ? "Redirecting to payment page"
          : ` Pay Now – ${cartTotal.toFixed(2)}`}
      </button>
    </div>
  );
};

export default GuestForm;
